/* Form validations errors messages */
export const VALIDATION_ERROR_MESSAGES = {
  required: 'Veuillez renseigner ce champ',
  invalid_email: 'Veuillez renseigner une adresse mail valide',
  len: 'Veuillez ne pas dépasser la limite de ce champ',
  passwordLen:
    'Veuillez renseigner un mot de passe qui dépasse ou égale les 6 caractères',
  pattern: 'Veuillez renseigner une valeur valide',
};

export const FORM_RULES = {
  required: {
    required: true,
    message: VALIDATION_ERROR_MESSAGES.required,
  },

  tel: {
    pattern: /^((\+)33|0)[1-9](\d{2}){4}$/i,
    message: VALIDATION_ERROR_MESSAGES.pattern,
  },

  email: {
    message: VALIDATION_ERROR_MESSAGES.required,
    type: 'email',
  },

  password: {
    min: 6,
    message: VALIDATION_ERROR_MESSAGES.passwordLen,
  },
};

export const SETTINGS_FORM = {
  text: [
    {
      required: true,
      message: VALIDATION_ERROR_MESSAGES.required,
    },
  ],
  tel: [
    {
      pattern: /^((\+)33|0)[1-9](\d{2}){4}$/i,
      message: VALIDATION_ERROR_MESSAGES.pattern,
    },
  ],
  email: [
    {
      message: VALIDATION_ERROR_MESSAGES.required,
      type: 'email',
    },
  ],
};

/* Constantes lié à l'animation auto */
export const TRIGGER = {
  inscription: 'onRegistrationUser',
  firstPublication: 'onFirstPublication',
  date: 'timer',
  publicationLikes: 'onPublicationLikeCount',
  publicationsCreated: 'onPublicationCount',
  commentsWritten: 'onCommentCount',
  reactionsGiven: 'onLikeCount',
  helpProvided: 'onHelpCount',
  helpOffered: 'onInterestCount',
};

/* Déclencheurs à seuil : la règle s'applique quand le compteur atteint exactement N */
export const COUNTER_TRIGGERS = [
  TRIGGER.helpOffered,
  TRIGGER.helpProvided,
  TRIGGER.publicationLikes,
  TRIGGER.publicationsCreated,
  TRIGGER.commentsWritten,
  TRIGGER.reactionsGiven,
];

export const PLATFORM = {
  maResidence: 'ROLE_MARESIDENCE,ROLE_MARESIDENCE_MOBILE',
  ensembl: 'ROLE_FRONT,ROLE_ENSEMBL_MOBILE',
  all: 'ALL',
};

export const CHANNEL = {
  pushCm: 'push',
  publication: 'publication',
  privateMessage: 'private_message',
  notification: 'notification',
};

export const TARGET = {
  national: 'national',
  clients: 'clients',
  city: 'city',
};

export const RECURRENT = {
  daily: 'everyDay',
  weekly: 'weekly',
  monthly: 'monthly',
  yearly: 'yearly',
};

export const VALUATION = {
  helpers: 'helpers',
  needers: 'needers',
  participation: 'participation',
  activities: 'activities',
  reactions: 'reactions',
  pendingDemands: 'pending_demands',
  activeDiscussions: 'active_discussions',
};

export const PUSH_CM_PUBLICATION_TYPES = [
  {
    title: 'Proposer un service',
    url: 'actualites/publication/creer/proposer-service',
  },
  {
    title: "Demander de l'aide",
    url: 'actualites/publication/creer/demander-aide',
  },
  {
    title: 'Publier une information',
    url: 'actualites/publication/creer/publier-information',
  },
];

export const PLATFORM_PUBLICATION = {
  maResidence: ['ROLE_MARESIDENCE', 'ROLE_MARESIDENCE_MOBILE'],
  ensembl: ['ROLE_FRONT', 'ROLE_ENSEMBL_MOBILE'],
};

export const CUSTOMER_TYPE = {
  association: { type: 'association', name: 'Association' },
  ccas: { type: 'ccas', name: 'CCAS' },
  assistance_provider: { type: 'assistance_provider', name: 'Téléassisteur' },
  clic: { type: 'clic', name: 'CLIC' },
  department: { type: 'department', name: 'Département' },
  social_center: { type: 'social_center', name: 'Centres sociaux' },
  national: { type: 'national', name: 'National' },
  real_estate_player: { type: 'real_estate_player', name: 'Habitat' },
};

export const MR_PLATFORM = 'maResidence';
export const ENSEMBL_PLATFORM = 'ensembl';
export const ROLES = {
  ROLE_CUSTOMER: 'ROLE_CUSTOMER',
  ROLE_ADMIN: 'ROLE_ADMIN',
  ROLE_NEIGHBOUR: 'ROLE_NEIGHBOUR',
  ROLE_INTERNAL: 'ROLE_INTERNAL',
};

export const GROUP_ROLES: Record<string, string> = {
  member: 'Membre',
  administrator: 'Administrateur',
  // legacy typo kept for safety in case some payloads still use it
  adminisitrator: 'Administrateur',
};

export const CATEGORIES_TYPES = [
  { label: 'alert', value: 'alert' },
  { label: 'association', value: 'association' },
  { label: 'badge', value: 'badge' },
  { label: 'culture_and_art', value: 'culture_and_art' },
  { label: 'field_of_activity', value: 'field_of_activity' },
  { label: 'drinking_eating', value: 'drinking_eating' },
  { label: 'going_out', value: 'going_out' },
  { label: 'language', value: 'language' },
  { label: 'other', value: 'other' },
  { label: 'service_offer', value: 'service_offer' },
  { label: 'service_need', value: 'service_need' },
  { label: 'shop', value: 'shop' },
  { label: 'solidarity', value: 'solidarity' },
  { label: 'sport', value: 'sport' },
  { label: 'travel', value: 'travel' },
];

export const PUBLICATIONS_TYPES = {
  news: { label: 'Information', color: 'blue' },
  poll: { label: 'Sondage', color: 'green' },
  event: { label: 'Évènement', color: 'red' },
};

export const BADGES_TRIGGER = [
  { label: 'onCommentCount', value: 'onCommentCount' },
  { label: 'onNewsCount', value: 'onNewsCount' },
  { label: 'onLikeCount', value: 'onLikeCount' },
  { label: 'onInterestCount', value: 'onInterestCount' },
  { label: 'onProfileCompletion', value: 'onProfileCompletion' },
];

export const TAB_SETTINGS = [
  { name: 'timeline_displayed', label: 'Timeline' },
  { name: 'mutual_aid_displayed', label: 'Entraide' },
  { name: 'communities_displayed', label: 'Communautés' },
  { name: 'wellbeing_displayed', label: 'Bien-être' },
  { name: 'events_displayed', label: 'Évènements' },
];
